import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-callc_order",
  "use": "icon-callc_order-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol viewBox=\"0 0 36 36\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-callc_order\"><clipPath id=\"icon-callc_order_a\"><path d=\"m0 0h36v36h-36z\" /></clipPath><g clip-path=\"url(#icon-callc_order_a)\" fill=\"none\" stroke=\"#4bd214\" stroke-width=\"2\"><g stroke-linecap=\"round\"><path d=\"m30 17.125v-4.187-6.188c0-.828-.672-1.5-1.5-1.5h-3.713-1.537v2.25h-10.5v-2.25h-.75-4.5c-.828 0-1.5.672-1.5 1.5v24.75c0 .828.672 1.5 1.5 1.5h5.25 1.25\" stroke-linejoin=\"round\" /><path d=\"m23.25 3h-10.5v4.5h10.5z\" stroke-linejoin=\"round\" /><path d=\"m21 24v4\" stroke-miterlimit=\"2\" /><path d=\"m25 24v4\" stroke-miterlimit=\"2\" /></g><circle cx=\"23\" cy=\"26\" r=\"7\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/callc_order.svg
// module id = Ecw0
// module chunks = 87